import React from "react";
import { homeObjOne} from './Data';
import { InfoSection } from "../Homepagesubfiles";

function Zerothcomponent(){
    return(
        <>
            <InfoSection {...homeObjOne} />   
        </>
    )
}

export default Zerothcomponent;